export const HALYARD = {
  FONT_STACK: 'halyard-text, sans-serif',
  DISPLAY: 'halyard-display, sans-serif',
};

export const SIZES = {
  MAX_WIDTH: '1200px',
};
